import React from "react";
import { ContextFilter } from "src/context/type";

export type IPropertyTableFilterContext<T = AdminAPI.Property.PropertyTableFilter> = ContextFilter<T>;

// @ts-ignore
const PropertyTableFilterContext = React.createContext<IPropertyTableFilterContext>(undefined);

export default PropertyTableFilterContext;
